import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CACHE_DURATION } from '#/shared/constants';

const api = {
  host: 'https://maps.trimet.org',
  services: {
    fullRouteGeometry: {
      path: '/wfs',
      defaultQuery: {
        service: 'WFS',
        version: '1.0',
        request: 'GetFeature',
        typeName: 'current:route',
        maxFeatures: 8,
        srsName: 'EPSG:4326',
        outputFormat: 'json',
      },
    },
  },
};

export const mapsApi = createApi({
  reducerPath: 'mapsApi',
  baseQuery: fetchBaseQuery({ baseUrl: api.host }),
  refetchOnReconnect: true,
  endpoints: build => ({
    getFullRouteGeometry: build.query({
      query: routeIds => {
        if (!routeIds || routeIds?.length < 1) return {};

        const { path, defaultQuery } = api.services.fullRouteGeometry;
        const routeIdMarkup = routeIds.map(
          rId => `
            <PropertyIsEqualTo>
              <PropertyName>id</PropertyName>
              <Literal>${rId}</Literal>
            </PropertyIsEqualTo>`
        );

        return {
          url: path,
          params: {
            ...defaultQuery,
            FILTER: `
              <Filter>
                <Or>${routeIdMarkup}</Or>
              </Filter>
            `,
          },
        };
      },
      keepUnusedDataFor: CACHE_DURATION.ONE_HOUR,
    }),
  }),
});

export const { useGetFullRouteGeometryQuery } = mapsApi;
